document.documentElement.classList.remove('no-js');

// Schließt das mobile Menü nach einem normalen Navigationsklick.
document.addEventListener('click', function (event) {
  var link = event.target.closest('.mobile-menu__panel a');
  if (!link) return;
  var details = link.closest('details');
  if (details) details.removeAttribute('open');
});
